import BuildingType from "@/roc/building/BuildingType";
import BuildingMaxLevel from "@/roc/building/BuildingMaxLevel";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import Happiness from '@/roc/effects/CultureBonus/Happiness';
import PassiveAura from "@/roc/effects/PassiveAura/PassiveAura";
import PassiveAuraType from "@/roc/effects/PassiveAura/PassiveAuraType";
import EffectAmount from "@/roc/effects/EffectAmount";

const SmallHome = {
  id: "1",
  name: "Small Home",
  width: 2,
  height: 2,
  type: BuildingType.HOME,
  era: "stoneAge",
  icon: "Worker",
  workers: 1,
  minLevel: 1,
  maxLevel: BuildingMaxLevel.THREE_OFF,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Homes/Small_Home',
  flags: 0,
  counts: {
    stoneAge: 7,
    bronzeAge: 12,
    minoanEra: 14,
    classicGreece: 18,
    earlyRome: 20,
    romanEmpire: 22,
    byzantineEra: 24,
    ageOfTheFranks: 25,
    feudalAge: 26,
    iberianEra: 27,
    kingdomOfSicily: 28,
    highMiddleAges: 29,
    earlyGothicEra: 30,
    lateGothicEra: 31,
  },
  effects: Effects.create([
    new PassiveProduction(
      ProductionDuration.asFlat(1 * 60 * 60),
      ProductionOutput
        .asPerLevel([
          300, 583, 883, 1017, 1117, 1173, 1290, 1355, 1423, 1565, 1643, 1733, 1867,
          1934, 2017, 2183, 2267, 2350, 2533, 2633, 2733, 2917, 3000, 3083, 3300,
          3400, 3500, 3750, 3867, 3983, 4267, 4400, 4533, 4850, 5000, 5150, 5333,
          5583, 5833, 6083, 6333, 6583,
        ])
        .withOutput(ProductionOutputType.GOLD)
      ,
    ),
    new Happiness({
      stoneAge: [70, 150, 300],
      bronzeAge: [110, 220, 440],
      minoanEra: [150, 300, 590],
      classicGreece: [200, 390, 790],
      earlyRome: [250, 490, 980],
      romanEmpire: [300, 590, 1180],
      byzantineEra: [340, 690, 1380],
      ageOfTheFranks: [420, 840, 1670],
      feudalAge: [490, 980, 1970],
      iberianEra: [590, 1180, 2360],
      kingdomOfSicily: [710, 1430, 2850],
      highMiddleAges: [860, 1720, 3440],
      earlyGothicEra: [1030, 2070, 4130],
      lateGothicEra: [1200, 2420, 4820],
    }),
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asFlat(1),
    ),
  ]),
};

export default SmallHome;
